import Router from 'vue-router';
import Login from '@/components/Login.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import helper from '@/commons/helper';

const generateRoutes = () => {
  const data = helper.Session.getLoginSettings();
  switch (data.portal) {

    case helper.Portals.OWNER: {
      return [
        {
          path: '/',
          component: () => import('@/layouts/AdminOwnerLayout.vue'),
          children: [
            {
              path: 'calendar',
              name: 'calendar',
              component: () => import('@/components/owner/Calendar.vue')
            },
            {
              path: 'account',
              name: 'account',
              component: () => import('@/components/owner/AccountInformation.vue')
            },
            {
              path: 'statement',
              name: 'statement',
              component: () => import('@/components/owner/Statement.vue')
            },
            {
              path: 'book-unit',
              name: 'book-unit',
              component: () => import('@/components/owner/BookingUnit.vue')
            },
            {
              path: 'rent',
              name: 'rent',
              component: () => import('@/components/owner/RentNights.vue')
            }
          ]
        },
        {
          path: '/login',
          name: 'login',
          component: Login
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: ForgotPassword
        },
        {
          path: '*',
          name: 'page-404',
          component: () => import('@/components/NotFound.vue')
        }
      ];
    }

    case helper.Portals.VENDOR: {
      return [
        {
          path: '/',
          component: () => import('@/layouts/AdminOwnerLayout.vue'),
          children: [
            {
              path: '/',
              redirect: {
                name: 'reservations-to-clean'
              }
            },
            {
              path: 'reservations-to-clean',
              name: 'reservations-to-clean',
              component: () => import('@/components/cleaning/ReservationsToClean.vue')
            },
            {
              path: 'arrival-reservations',
              name: 'arrival-reservations',
              component: () => import('@/components/cleaning/ArrivalReservations.vue')
            },
            {
              path: 'account',
              name: 'cleaning-account-info',
              component: () => import('@/components/cleaning/AccountInformation.vue')
            }
          ]
        },
        {
          path: '/login',
          name: 'login',
          component: Login
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: ForgotPassword
        },
        {
          path: '*',
          name: 'page-404',
          component: () => import('@/components/NotFound.vue')
        }
      ];
    }

    case helper.Portals.RESERVATION: {
      return [
        {
          path: '/',
          component: () => import('@/layouts/AdminOwnerLayout.vue'),
          children: [
            {
              path: '/',
              redirect: {
                name: 'summary'
              }
            },
            {
              path: '/summary',
              name: 'summary',
              component: () => import('@/components/reservation/ReservationSummary.vue')
            },
            {
              path: '/unit-details',
              name: 'unit-details',
              component: () => import('@/components/reservation/UnitDetails.vue')
            },
            {
              path: '/transactions',
              name: 'transactions',
              component: () => import('@/components/reservation/Transactions.vue')
            },
            {
              path: '/make-payment',
              name: 'make-payment',
              component: () => import('@/components/reservation/MakePayment.vue')
            }

          ]
        },
        {
          path: '/login',
          name: 'login',
          component: Login
        },
        {
          path: '*',
          name: 'page-404',
          component: () => import('@/components/NotFound.vue')
        }
      ];
    }

    case helper.Portals.STAFF: {
      return [
        {
          path: '/',
          component: () => import('@/layouts/AdminOwnerLayout.vue'),
          children: [
            {
              path: '',
              redirect: 'lookup'
            },
            {
              path: 'lookup',
              name: 'lookup',
              component: () => import('@/components/staff/LookUp.vue')
            },
            {
              path: 'unit-calendar',
              name: 'unit-calendar',
              component: () => import('@/components/staff/UnitCalendar.vue')
            },
            {
              path: 'book-reservation',
              name: 'book-reservation',
              component: () => import('@/components/staff/BookReservation.vue')
            },
            {
              path: 'search-availability',
              name: 'search-availability',
              component: () => import('@/components/staff/SearchAvailability.vue')
            },
            {
              path: 'reservation-payment',
              name: 'reservation-payment',
              component: () => import('@/components/staff/ReservationPayment.vue')
            }
          ]
        },
        {
          path: '/login',
          name: 'login',
          component: Login
        },
        {
          path: '*',
          name: 'page-404',
          component: () => import('@/components/NotFound.vue')
        }
      ];
    }
  }
};

export default new Router({
  mode: 'hash',
  routes: generateRoutes()
});
